import React, { type FC, type HTMLAttributes, useMemo } from "react";
import { useAuth } from "../../context/auth/AuthProvider";

import { Button } from "../Button";
import { Link } from "../Link";
import * as styles from "./MembershipGateMidgate.module.scss";

interface Props extends HTMLAttributes<HTMLElement> {
	title: string,
	subtext: string,
	registerButtonText: string,
	loginButtonText: string,
	benefitList: string[],
}

export const MembershipGateMidgate: FC<Props> = ({
	title,
	subtext,
	registerButtonText,
	loginButtonText,
	benefitList,
	...props
}) => {
	const { loginOrMyAccount } = useAuth();
  const headingId = "membership-midgate-title";

	return (
		<section className={styles.component} aria-labeledby={headingId}>
			<h2 id={headingId}>{title}</h2>
			<p>{subtext}</p>


			<div className={styles.buttonGroup}>
                <button
                    type="button"
                    className={styles.button}
                    onClick={loginOrMyAccount}
                >
                    {registerButtonText}
                </button>
				<button
					type="button"
					className={styles.loginButton}
					onClick={loginOrMyAccount}
				>
					{loginButtonText}
				</button>
			</div>

			<ul className={styles.benefitsList}>
				{benefitList.map((benefit, index) => (
					<li key={index}>
						{benefit}
					</li>
				))}
			</ul>
        </section>
	);
};

export default MembershipGateMidgate;
